import { SortBoolAscendingVariantIcon } from './SortBoolAscendingVariantIcon';

/**
 * author: frankgrinaert
 * id 9F0F11BF-8F55-45CD-B185-7C8BC278954C
 * name sort-bool-ascending-variant
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sort-bool-ascending-variant.svg
 * tags
 * - Text / Content / Format 
 */
export const SortCheckboxAscendingIcon = SortBoolAscendingVariantIcon;
export default SortCheckboxAscendingIcon